/**
 * Updated by Vinicius
 */

import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  takeUntil,
} from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { fromEvent } from 'rxjs';
import { NbToastrService, NbDialogService } from '@nebular/theme';

import {
  CustomExercise,
  CustomExerciseData,
  CustomExerciseFilter,
} from 'app/@core/interfaces/common/CalorieFriend/custom-exercise';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';
import { CustomExerciseDefComponent } from '../CustomExerciseDef/customexercise-def.component';

@Component({
  selector: 'app-custom-exercise-list',
  templateUrl: './exercise-list.component.html',
  styleUrls: ['./exercise-list.component.scss'],
})
export class CustomExerciseListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: true }) sortor?: MatSort;
  @ViewChild('search', { static: true }) searchInput?: ElementRef;

  readonly displayedColumns = ['image', 'name', 'updatedDate', 'actions'];
  totalCount: number = 0;
  dataList: CustomExercise[] = [];
  contentLoaded:boolean = false;

  private unsubscribe$ = new Subject<void>();
  private paging: CustomExerciseFilter = {
    sortBy: 'updatedDate',
    orderBy: 'desc',
  };

  constructor(
    private customExerciseService: CustomExerciseData,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    // default sort and load data initially
    this.sortor.sort({
      id: this.paging.sortBy,
      start: this.paging.orderBy,
    } as MatSortable);

    fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((x) => x !== this.paging.Name),
        debounceTime(250),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        this.paging.Name = this.searchInput.nativeElement.value;
        this.loadDataList();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSortChanged(sort: Sort): void {
    this.paging.sortBy = sort.active;
    this.paging.orderBy = sort.direction;
    this.loadDataList(true);
  }

  loadDataList(pagination: boolean = false): void {
    if (!pagination && this.paginator) this.paginator.pageIndex = 0;
    this.paging.pageNumber = pagination
      ? this.paginator?.pageIndex + 1 ?? 1
      : 1;
    this.paging.pageSize = this.paginator?.pageSize ?? 10;

    this.customExerciseService
      .list(this.paging)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.totalCount = res.totalCount;
        res.items.forEach((x) => {
          x.exerciseVideoThumbnailUrl = x.exerciseVideoThumbnailUrl && x.exerciseVideoThumbnailUrl !== 'null'? x.exerciseVideoThumbnailUrl : null;
        });
        this.dataList = res.items;
        this.contentLoaded = true;
      });
  }


  public getVideoUrl(source:string):string {
    return source + "#t=0.001"
  }

  onAddCustomExercise() {
    this.dialogService
      .open(CustomExerciseDefComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: { ID: null },
      })
      .onClose.subscribe((res) => {
        //if (!res) return;
        this.loadDataList(true);
      });
  }

  onEdit(id: number) {
    this.dialogService
      .open(CustomExerciseDefComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: { ID: id },
      })
      .onClose.subscribe((res) => {
        //if (!res) return;
        this.loadDataList(true);
      });
  }

  onDelete(id: number) {
    this.dialogService
      .open(ConfirmMessageDialogComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: { Message: 'Are you sure to delete this custom exercise?' },
      })
      .onClose.subscribe((res) => {
        if (!res) return;
        this.customExerciseService
          .delete(id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            () => {
              this.toastrService.success(
                '',
                'Successfully deleted Custom Exercise',
              );
              this.loadDataList(true);
            },
            () =>
              this.toastrService.danger(
                '',
                'Problem occurred delelting Custom Exercise',
              ),
          );
      });
  }
}
